module.exports = __webpack_public_path__ + "static/media/futuregrad_logomark_white.d4086cbe.svg";